/**
 * Await `action`, then run `cleanup` however the action ended: resolved,
 * rejected, or returned early. The action's result or error passes through,
 * exactly as `try { return await action(); } finally { cleanup(); }` would.
 *
 * Components and hooks call this instead of writing a `finally` clause. React
 * Compiler cannot compile a function that contains one, a nested callback's
 * included, and leaves the whole component or hook unmemoized; the clause is
 * safe here because nothing at module level is compiled. A `cleanup` that
 * throws replaces the action's outcome, as it would in a `finally` clause.
 */
export async function withCleanup<T>(action: () => Promise<T>, cleanup: () => void): Promise<T> {
  try {
    return await action();
  } finally {
    cleanup();
  }
}
